// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface EmailReadIconSignature {
  Element: SVGSVGElement;
}

export const EmailReadIcon: TOC<EmailReadIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.874 3.218C12.814 2.371 11.232 2.332 10.08 3.257L2 10.556V20C2 21.103 2.896 22 4 22H20C21.104 22 22 21.103 22 20V10.556L13.874 3.218ZM11.375 4.78C11.732 4.494 12.312 4.531 12.578 4.74L19.376 10.881L14.697 14H9.303L4.623 10.881L11.375 4.78ZM4 12.868V20H20.002L20 12.868L15.302 16H8.697L4 12.868Z"/>
</svg>
</template>;